export default __webpack_public_path__ + "static/media/butterfly1.374b90f7.svg";